<template>
    <div class="group">
        <a :href="`/author/${encodeURIComponent(author.name)}`" class="block">
            <div :style="getImageContainerStyle()"
                class="bg-creme-200 mb-4 overflow-hidden hover:shadow-lg transition-shadow cursor-pointer w-full">
                <div v-if="author.image" class="w-full h-full">
                    <img :src="author.image" :alt="author.name"
                        class="w-full h-auto min-h-full object-cover object-center" />
                </div>
                <div v-else class="w-full h-full flex items-center justify-center text-gray-400">
                    <svg class="w-24 h-24" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                    </svg>
                </div>
            </div>
        </a>
        <a :href="`/author/${encodeURIComponent(author.name)}`" class="block">
            <h3 class="font-header font-semibold text-primary mb-1 text-sm hover:text-accent transition-colors"
               >
                {{ author.name }}
            </h3>
        </a>
        <p v-if="author.bookCount" class="text-gray-600 text-xs mb-2 font-body">
            {{ author.bookCount }} {{ author.bookCount === 1 ? 'book' : 'books' }}
        </p>
        <p v-if="author.location" class="text-gray-500 text-xs font-body">
            {{ author.location }}
        </p>
    </div>
</template>

<script setup>
import { useAuthorImageStyle } from '../composables/useAuthorImageStyle'

const { getAuthorImageContainerStyle } = useAuthorImageStyle()

const props = defineProps({
    author: {
        type: Object,
        required: true
    }
})

const getImageContainerStyle = () => {
    return getAuthorImageContainerStyle(props.author)
}
</script>

<style scoped></style>
